import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from "../../../common/IconButton";
import {buyCourse} from "../../../../services/operations/studentFeaturesAPI";
import { useNavigate } from 'react-router-dom';

function RenderTotalAmount(props) {

    const {total,cart} = useSelector((state) => state.cart);
    const {token} = useSelector((state)=>state.auth);
    const {user} = useSelector((state)=>state.profile);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    /*
        Fixed add to cart
    */
    // useEffect(()=>{
    //     console.log("Cart: ",cart)
    //     const courses = cart.map((course) => course._id);
    //     console.log("Bought these courses: ",courses);
    // })

    function handleBuyCourse()
    {
        const courses = cart.map((course) => course._id);
        // console.log("Bought these courses: ",courses);
        buyCourse(token,courses,user,navigate,dispatch);

        // Todo: API integration
    }

    return (
        <div className='bg-richblack-800 w-[25%] max-[450px]:w-[100%] p-4 mt-5 shadow-sm shadow-richblack-400'>
            <div>
                <p className='text-lg text-richblack-200'>Total:</p>
                <p className='text-2xl text-yellow-25'>Rs. {total}</p>

                <IconButton
                    text={"Buy Now"}
                    onclick={handleBuyCourse}
                    customClasses={"w-full rounded-md py-1 mt-5 bg-yellow-25 text-richblack-900"}
                />

            </div>
        </div>
    );
}

export default RenderTotalAmount;